<label class="content__button">
  <label class="button__descricao">
    <span>Itens por página </span>
    <ng-select [(ngModel)]="pageItens" id="ng-select-filter" [items]="itens" bindLabel="name" bindValue="id">
    </ng-select>
    <span> de <span class="descricao__valor__total">{{ totalItens }}</span> resultados</span>
  </label>
</label>